import { cn } from '@exam-room/utils';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

import { ExpandMoreOutlinedIcon } from '../icons';
interface LanguageSwitchMenuProps {
  onSwitchToThai: () => void;
  onSwitchToEnglish: () => void;
  currentLanguage: string;
}

export function LanguageSwitchMenu(props: LanguageSwitchMenuProps) {
  const { onSwitchToThai, onSwitchToEnglish, currentLanguage } = props;
  return (
    <Menu>
      <MenuButton>
        {({ active }) => (
          <div
            className={cn(
              'inline-flex w-20 cursor-pointer items-center gap-2 rounded-md border border-gray-300 px-3 py-2',
              active && 'border-primary-500 ring-primary-300 ring-[3px]',
            )}
          >
            <span>{currentLanguage}</span>
            <div
              className={cn(
                'transition-transform duration-300 ease-in-out',
                active ? '-rotate-180' : 'rotate-0',
              )}
            >
              <ExpandMoreOutlinedIcon />
            </div>
          </div>
        )}
      </MenuButton>
      <MenuItems
        anchor='bottom start'
        transition
        className='z-[1000] mt-1 w-[140px] origin-top scale-y-100 rounded-lg border-[0.5px] border-gray-300 bg-white p-2 opacity-100 shadow-lg data-[closed]:scale-y-0 data-[closed]:opacity-0'
      >
        <MenuItem>
          {({ focus }) => (
            <button
              className={cn(
                'block w-full cursor-pointer rounded-md px-2 py-1.5 text-left',
                focus && 'bg-primary-100',
              )}
              type='button'
              onClick={onSwitchToThai}
            >
              Thai
            </button>
          )}
        </MenuItem>
        <MenuItem>
          {({ focus }) => (
            <button
              className={cn(
                'block w-full cursor-pointer rounded-md px-2 py-1.5 text-left',
                focus && 'bg-primary-100',
              )}
              type='button'
              onClick={onSwitchToEnglish}
            >
              English
            </button>
          )}
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
